import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  CheckSquare, 
  BarChart3, 
  Settings, 
  ChevronLeft,
  ChevronRight,
  Clock,
  Calendar,
  Target,
  Heart,
  Brain,
  Briefcase,
  User
} from 'lucide-react';
import { calculateAge } from '../utils/dateUtils';

const Sidebar = ({ isOpen, onToggle, categories, userProfile }) => {
  const location = useLocation();

  const mainLinks = [
    { path: '/', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/todos', icon: CheckSquare, label: 'All Todos' },
    { path: '/analytics', icon: BarChart3, label: 'Analytics' },
    { path: '/settings', icon: Settings, label: 'Settings' },
  ];

  const timeframes = [
    { path: '/todos/today', icon: Clock, label: 'Today' },
    { path: '/todos/this-week', icon: Calendar, label: 'This Week' },
    { path: '/todos/this-month', icon: Target, label: 'This Month' },
    { path: '/todos/this-quarter', icon: Briefcase, label: 'This Quarter' },
  ];

  const categoryIcons = {
    personal: User,
    learning: Brain,
    mental: Heart,
    work: Briefcase,
  };

  const age = userProfile?.birthDate ? calculateAge(userProfile.birthDate) : null;

  return (
    <>
      <aside className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          {isOpen && (
            <div className="sidebar-brand">
              <CheckSquare size={28} strokeWidth={2.5} />
              <h1>TaskFlow</h1>
            </div>
          )}
          <button className="sidebar-toggle" onClick={onToggle}>
            {isOpen ? <ChevronLeft size={20} /> : <ChevronRight size={20} />}
          </button>
        </div>

        {age && isOpen && (
          <div className="age-display">
            <div className="age-number">
              {age.years}<span className="age-unit">y</span> 
              {age.months}<span className="age-unit">m</span> 
              {age.days}<span className="age-unit">d</span>
            </div>
            <div className="age-subtitle">
              {age.totalDays.toLocaleString()} days of life
            </div>
          </div>
        )}

        <nav className="sidebar-nav">
          <div className="nav-section">
            {isOpen && <h3 className="nav-title">Main</h3>}
            {mainLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
                title={!isOpen ? link.label : ''}
              >
                <link.icon size={20} />
                {isOpen && <span>{link.label}</span>}
              </Link>
            ))}
          </div>

          <div className="nav-section">
            {isOpen && <h3 className="nav-title">Timeframes</h3>}
            {timeframes.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
                title={!isOpen ? link.label : ''}
              >
                <link.icon size={20} />
                {isOpen && <span>{link.label}</span>}
              </Link>
            ))}
          </div>

          {categories.length > 0 && (
            <div className="nav-section">
              {isOpen && <h3 className="nav-title">Categories</h3>}
              {categories.map((category) => {
                const IconComponent = categoryIcons[category.icon] || CheckSquare;
                return (
                  <Link
                    key={category.id}
                    to={`/todos?category=${category.id}`}
                    className={`nav-link category-link`}
                    title={!isOpen ? category.name : ''}
                  >
                    <IconComponent size={20} />
                    {isOpen && <span>{category.name}</span>}
                    <span 
                      className="category-color" 
                      style={{ backgroundColor: category.color }}
                    />
                  </Link>
                );
              })}
            </div>
          )}
        </nav>

        {isOpen && (
          <div className="sidebar-footer">
            <p className="version">v1.0.0</p>
          </div>
        )}
      </aside>
    </>
  );
};

export default Sidebar;
